import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const casestudyImporterSelectors = importerSelectors(
  'casestudy.importer',
);

export default casestudyImporterSelectors;
